export const cleanstr = str =>
  str.trim();

export default cleanstr;



// WEBPACK FOOTER //
// ./src/app/utils/cleanstr.js